import { color } from "html2canvas/dist/types/css/types/color";

export const NDRE_DATA = [
    { classValue: 1, color: '#fff5ec', label: 'Non-Vegetated', colorName: 'OFFWHITE', interval: '< 0.0'},
    { classValue: 2, color: '#FFDAB9',   label: 'Bare Soil', colorName: 'ORANGE', interval: '< 0.15' },
    { classValue: 3, color: '#e6e600',  label: 'Sparse/Stressed',  colorName: 'YELLOW', interval: '< 0.30'  },
    { classValue: 4, color: '#bfff00', label: 'Moderate Healthy',  colorName: 'LIGHTGREEN', interval: '< 0.50'  },
    { classValue: 5, color: '#00d400',     label: 'Healthy',  colorName: 'GREEN', interval: '< 0.65' },
    { classValue: 6, color: '#00e6ac',    label: 'Mature',  colorName: 'DARKGREEN', interval: '> 0.65' }
];

export const NDVI_DATA = [
    { classValue: 1, range: '-1.0 to 0', label: 'Water',color: '#FFDAB9' },
    { classValue: 2, range: '0 to 0.2', label: 'Bare Soil', color: '#e6e600' },
    { classValue: 3, range: '0.2 to 0.4', label: 'Low Vegetation', color: '#CEFF33' },
    { classValue: 4, range: '0.4 to 0.6', label: 'Moderate Vegetation', color: '#8DD874' },
    { classValue: 5, range: '0.6 to 0.8', label: 'Healthy Vegetation', color: '#00CC00' },
    { classValue: 6, range: '0.8 to 1.0', label: 'Dense Forest', color: '#275216' }
]

export const NCCI_DATA = [
  { classValue: 1,range: '-1.0 to 0', label: "Water/Soil", value: 1, color: "#fff5ec" },
  { classValue: 2, range: '0 to 0.2', label: "Very Low", value: 2, color: "#414487" },
  { classValue: 3, range: '0.2 to 0.4', label: "Low Nitrogen", value: 3, color: "#2A788E" },
  { classValue: 4, range: '0.4 to 0.6', label: "Moderate Nitrogen", value: 4, color: "#22A884" },
  { classValue: 5, range: '0.6 to 0.8', label: "High Nitrogen", value: 5, color: "#FDE725" },
  { classValue: 6, range: '0.8 to 1.0', label: "Very High", value: 6, color: "#7AD151" }
];